import { RiResetLeftFill } from "react-icons/ri";

const ReloadButton = () => {
    const reloadPage = () => {
        window.location.reload();
    }
    
    return (
        <button 
            className="reload-button" 
            onClick={() => reloadPage()}
        > <RiResetLeftFill /> </button>
    )
}

export default ReloadButton;